import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { AssetScope } from 'src/app/helpers/enum/asset-scope.enum';
import { AssignedTrailersResponse, InsertInspectionReport, InspectionReportDetailsResponse, InspectionsList, InspectionTypeItemsResponse, InspectionTypesResponse, SubmitOdometerPayload, SubmittedSummaryResponse } from 'src/app/models/inspection.model';
import { Observable } from 'rxjs';
import { VehicleProvider } from '../providers/vehicle-provider/vehicle-provider';
import { CoreService } from '../core/core.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class InspectionService {

  constructor(private readonly apiService: ApiService,
    private readonly vehicleProvider: VehicleProvider,
    private readonly coreService: CoreService,
    private readonly router: Router
  ) { }

  getVehicleInspectionReport(reportId: string, icnNo: string) {
    return this.apiService.get<InspectionReportDetailsResponse>(`GetVehicleInspectionReportDetail?inspectionReportId=` + reportId + `&icnNo=` + icnNo)
  }

  getInspectionType(icnNo: string | null = null, assetScope: AssetScope | null = null) {
    // Omit the param entirely when null, rather than sending the literal string 'null'
    const assetScopeParam = assetScope ? `&assetScope=${assetScope}` : '';
    return this.apiService.get<InspectionTypesResponse[]>(`GetInspectionTypes?icnNo=${icnNo ?? null}${assetScopeParam}`);
  }

  getInspectionTypeItems(inspectionTypeId: string) {
    return this.apiService.get<InspectionTypeItemsResponse[]>(`GetInspectionItem?vehInspectTypeID=${inspectionTypeId}`);
  }

  InsertReport(payload: InsertInspectionReport) {
    return this.apiService.post<InsertInspectionReport, number>(`InsertInspectionReport`, payload);
  }

  saveKM(icnNo: string, data: SubmitOdometerPayload): Observable<any> {
    return this.apiService.post<SubmitOdometerPayload, any>(`odometer/${icnNo}/save/odometer-reading`, data);
  }

  getInspectionsAssignedTrailer(icnNo: string) {
    return this.apiService.get<AssignedTrailersResponse>(`inspectionsTrailer/${icnNo}/DriverPreUseInspectionsTrailer`);
  }

  getSubmittedSummaryWithDefects(icnNo: string) {
    return this.apiService.get<SubmittedSummaryResponse>(`inspections/${icnNo}/GetSubmittedSummaryWithDefects`);
  }

  getInspections(icnNo: string) {
    return this.apiService.get<InspectionsList>(`inspections/${icnNo}/DriverPreUseInspections`);
  }

  async navigatePUI(icnNo: string, isSelectedVehicleHasDefects?: boolean) {
    const vehicle = await this.vehicleProvider.getVehicleByIcnNo(icnNo);
    const idx = await this.vehicleProvider.getVehicleIdx(icnNo);
    if (!vehicle || idx == undefined) {
      return;
    }

    this.vehicleProvider.setSelectedVehicle(vehicle, idx);

    const showOpenDefect = isSelectedVehicleHasDefects ?? vehicle.safetY_DEFECT_COUNT > 0;

    if (this.isFeatureShowOpenDefectScreen && showOpenDefect) {
      this.router.navigate(['/open-defects', vehicle.icN_NO], {
        state: {
          vehicleData: vehicle
        }
      });
    }

    else {
      this.router.navigate(['/add-new-pre-use-inspection/0']);
    }
  }

  /* Gets the feature flag value for open defects screen */
  get isFeatureShowOpenDefectScreen() {
    return this.coreService.isFeatureFlagExists('FeatureShowOpenDefectScreen');
  }

}